import React from 'react';
import { Box, IconButton } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// Floating WhatsApp bubble (clickable) placed bottom-right
export default function FloatingInfo({ label }) {
	const openWhatsApp = () => {
		window.open('https://wa.me/+5491131601909', '_blank');
	};

	return (
		<Box
			id="floating-info"
			sx={{
				position: 'fixed',
				bottom: 20,
				right: 20,
				width: 80,
				height: 80,
				borderRadius: '50%',
				backgroundColor: '#25D366',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				boxShadow: '0 6px 18px rgba(0,0,0,0.18)',
				zIndex: 2000,
			}}
			role="button"
			aria-label={label || 'WhatsApp'}
		>
			<IconButton
				onClick={openWhatsApp}
				sx={{ color: '#fff', pointerEvents: 'auto' }}
				aria-label="Abrir WhatsApp"
			>
				<WhatsAppIcon sx={{ fontSize: 34 }} />
			</IconButton>
		</Box>
	);
}
